import React from 'react'
import { css, SerializedStyles } from '@emotion/core'
import { HeaderHeight } from './header'
import { FrontTabletFontSize } from '@/constants/front-tablet-typography'

type ComponentProps = {
  subtitle?: string | JSX.Element
  style?: SerializedStyles
}

export const Body: React.FC<ComponentProps> = props => {
  return (
    <div css={[componentStyle, props.style]}>
      {props.subtitle && typeof props.subtitle !== 'string' ? props.subtitle : <p className="subtitle">{props.subtitle}</p>}
      <div>{props.children}</div>
    </div>
  )
}

const componentStyle = css({
  width: '100%',
  position: 'relative',
  backgroundColor: '#F2F2F2',
  paddingTop: HeaderHeight,
  minHeight: '100vh',
  '>div': { maxWidth: '90%', margin: 'auto', paddingBottom: 32 },
  '.subtitle': {
    textAlign: 'center',
    lineHeight: '31px',
    letterSpacing: '3.15px',
    fontSize: FrontTabletFontSize.pageTitle,
    fontWeight: 'bold',
    margin: '24px 0',
  },
})
